import React from "react";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { FormInput, FormTextArea, FormCheckbox, FormSwitch } from "../FormComponents";
import { requiredValidator } from "../Validators";

interface AddFormFormProps {
  onSubmit: (dataItem: any) => void;
  onCancel?: () => void;
}

const AddFormForm = ({ onSubmit, onCancel }: AddFormFormProps) => {
  const handleSubmit = (dataItem: any) => {
    // Format data for API
    const formData = {
      name: dataItem.name,
      description: dataItem.description || "",
      showLocationJobs: dataItem.showLocationJobs !== undefined ? dataItem.showLocationJobs : false,
      showLocationLinks: dataItem.showLocationLinks !== undefined ? dataItem.showLocationLinks : false,
      createFromTemplate: dataItem.createFromTemplate !== undefined ? dataItem.createFromTemplate : false,
      templateFilename: dataItem.templateFilename || "",
      automationUrl: dataItem.automationUrl || "",
      shortCode: dataItem.shortCode || "",
      autoGenerateForJob:
        dataItem.autoGenerateForJob !== undefined ? dataItem.autoGenerateForJob : false,
    };
    onSubmit(formData);
  };

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={{
        name: "",
        description: "",
        showLocationJobs: false,
        showLocationLinks: false,
        createFromTemplate: false,
        templateFilename: "",
        automationUrl: "",
        shortCode: "",
        autoGenerateForJob: false,
      }}
      render={(formRenderProps) => (
        <FormElement style={{ padding: "1rem", marginBottom: "5rem" }}>
          <fieldset className={"k-form-fieldset"}>
            <div className="form__subtitle">
              Add form details:
              <button
                className="form__reset__button"
                type="button"
                onClick={formRenderProps.onFormReset}
              >
                Clear fields
              </button>
            </div>

            <Field
              name={"name"}
              component={FormInput}
              label={"Form Name: "}
              placeholder={"Enter form name"}
              validator={requiredValidator}
            />

            <Field
              name={"description"}
              component={FormTextArea}
              label={"Description: "}
              placeholder={"Enter description"}
            />

            <Field
              name={"showLocationJobs"}
              component={FormCheckbox}
              label={"Show on Jobs"}
            />

            <Field
              name={"showLocationLinks"}
              component={FormCheckbox}
              label={"Show on Links"}
            />

            <Field
              name={"createFromTemplate"}
              component={FormSwitch}
              label={"Create from Template"}
            />

            {formRenderProps.valueGetter("createFromTemplate") && (
              <Field
                name={"templateFilename"}
                component={FormInput}
                label={"Template Filename: "}
                placeholder={"Enter template filename"}
              />
            )}

            <Field
              name={"automationUrl"}
              component={FormInput}
              label={"Automation URL: "}
              placeholder={"Enter automation URL (optional)"}
            />

            <Field
              name={"shortCode"}
              component={FormInput}
              label={"Short Code: "}
              placeholder={"Enter short code (optional)"}
              maxLength={50}
            />

            <Field
              name={"autoGenerateForJob"}
              component={FormSwitch}
              label={"Automatically generate form and add to job"}
            />
          </fieldset>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "1rem",
              marginTop: "1rem",
            }}
          >
            <button
              type="submit"
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
              disabled={!formRenderProps.allowSubmit}
            >
              Save Form
            </button>
            {onCancel && (
              <button
                type="button"
                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                onClick={onCancel}
              >
                Cancel
              </button>
            )}
          </div>
        </FormElement>
      )}
    />
  );
};

export default AddFormForm;
